import { ParentEvent, Tween } from "@g.frame/core";
import { DoubleSide, Euler, Group, Mesh, MeshBasicMaterial, MeshPhongMaterial, PlaneGeometry, Quaternion, Vector2, Vector3 } from "three";
import Stage from "../Stage";
import GaugeComponent from "./modules/GaugeComponent";
import SelectComponent from "../../modules/select/SelectComponent";
import SliderComponent from "../../modules/slider/SliderComponent";
import { ActionControllerEventName } from "@g.frame/common.action_controller";
import { TextComponent } from "@g.frame/components.text";
import { AUDIO, FBX_MODEL, OBJ_MODEL, TEXTURE } from "@g.frame/common.loaders";
import { OculusQuestModule } from "@g.frame/oculus.quest";
const needleConfig = {
    pickedPosition: new Vector3(1.0675, 1.2, 6.225),
    pickedRotation: new Euler(0, 0, 0)
};
const cameraPositions = {
    far: {
        camera: new Vector3(2.4985907862546424, 0.5425685920075562, 6.512107898966476),
        target: new Vector3(2.2392833757779287, 0.6173370617903847, 6.394831652938439)
    },
    closeVR: {
        camera: new Vector3(1.7598196779803044, 1.2112460211092546, 6.727995495436662),
        target: new Vector3(1.7416068001960707, 1.211024195504532, 6.7145468078080945),
    },
    close: {
        target: new Vector3(1.3096754005874776, 1.2279604880658082, 6.340103366918486),
        camera: new Vector3(1.3424045967392606, 1.2315689975016477, 6.362469332291584)
    }
};
const measurementConfig = [
    {
        rightValue: '36',
        options: ['0', '11', '25', '36', '47']
    },
    {
        rightValue: '75',
        options: ['0', '25', '50', '75', '100']
    },
    {
        rightValue: 'F',
        options: ['E', '|', '|', 'F']
    },
    {
        rightValue: ' | ',
        options: ['L', ' | ', '|', 'F']
    }
];
export default class TractorLevel extends Stage {
    constructor(modulesProcessor, uiManager, environment, levelsManager) {
        super(modulesProcessor, uiManager, environment);
        this.modulesProcessor = modulesProcessor;
        this.uiManager = uiManager;
        this.environment = environment;
        this.levelsManager = levelsManager;
        this.tractorAssets = new Group;
        this.parts = {};
        this.currentStep = 0;
        this.changeCameraPosition();
        this.gaugeComponents = [
            new GaugeComponent(),
        ];
        this.loader.addResources([{
                name: 'TEXTURE_start_engine_button',
                url: require('../../../assets/textures/tractor/start_engine_button.png'),
                type: TEXTURE
            }, {
                name: 'TEXTURE_fuel_gauge_bc',
                url: require('../../../assets/textures/tractor/fuel_gauge.png'),
                type: TEXTURE
            }, {
                name: 'TEXTURE_fuel_gauge_op',
                url: require('../../../assets/textures/tractor/fuel_gauge_alpha.png'),
                type: TEXTURE
            }, {
                name: 'TEXTURE_tractor_label',
                url: require('../../../assets/textures/tractor/label.png'),
                type: TEXTURE
            }, {
                name: 'TEXTURE_oil_stick',
                url: require('../../../assets/textures/tractor/oil_stick.png'),
                type: TEXTURE
            }, {
                name: 'MODEL_oil_stick',
                url: require('../../../assets/models/tractor/oil_stick.fbx'),
                type: FBX_MODEL
            }, {
                name: 'MODEL_coolant_scale',
                url: require('../../../assets/models/tractor/coolant_scale.obj'),
                type: OBJ_MODEL
            }, {
                name: 'AUDIO_tractor',
                url: require('../../../assets/audio/tractor.mp3'),
                type: AUDIO
            },
        ]);
        this.select = new SelectComponent(this.modulesProcessor);
        this.slider = new SliderComponent(this.modulesProcessor);
    }
    init() {
        // this.on('next_level_button', () => {
        //     this.fire('next_level', new ParentEvent('next_level', {level: '#Lobby'}));
        // });
        var _a;
        this.slider.init();
        this.slider.uiObject.scale.setScalar(.4375);
        this.isVr = !!((_a = this.modulesProcessor.modulesInstances.get(OculusQuestModule)) === null || _a === void 0 ? void 0 : _a.length);
        this.initAssets();
    }
    changeCameraPosition(far = true) {
        if (this.isVr) {
            this.controlsPosition = far ? cameraPositions.far : cameraPositions.closeVR;
        }
        else {
            this.controlsPosition = far ? cameraPositions.far : cameraPositions.close;
        }
    }
    startLevel() {
        this.once('start_level', () => {
            this.startSelection(true);
        });
        this.showStartMessage();
    }
    startSelection(brand) {
        let callback;
        if (brand) {
            this.nextStep(1);
            this.select.on('button_pressed', () => {
                const selectedButton = this.select.getSelection();
                if (selectedButton && selectedButton.userData.text === 'John Deere') {
                    this.select.off('click');
                    setTimeout(() => {
                        this.startSelection(false);
                    }, 500);
                }
            });
            // this.uiManager.textButton.on('click', callback = () => {
            //     const selectedButton = this.select.getSelection();
            //     if (selectedButton && selectedButton.userData.text === 'John Jeere') {
            //         this.uiManager.textButton.off('click', callback);
            //         this.startSelection(false);
            //     } else {
            //         this.uiManager.showFailPopUp();
            //     }
            // });
        }
        else {
            this.nextStep(2);
            this.select.on('button_pressed', () => {
                const selectedButton = this.select.getSelection();
                if (selectedButton && selectedButton.userData.text === '300') {
                    this.select.off('click');
                    setTimeout(() => {
                        this.startMeasurement(0);
                    }, 500);
                }
            });
            // this.uiManager.textButton.on('click', callback = () => {
            //     const selectedButton = this.select.getSelection();
            //     if (selectedButton && selectedButton.userData.text === '300') {
            //         this.uiManager.textButton.off('click', callback);
            //         this.startMeasurement(0);
            //     } else {
            //         this.uiManager.showFailPopUp();
            //     }
            // });
        }
    }
    startMeasurement(index) {
        this.nextStep(index + 3);
        if (measurementConfig[index]) {
            let callback;
            this.slider.setOptions(measurementConfig[index].options, measurementConfig[index].rightValue);
            if (index === 3) {
                this.showNeedle();
            }
            else if (index === 1) {
                this.changeCameraPosition(false);
                this.levelsManager.levelFlyTo(this);
                this.openDoor();
            }
            this.gaugeComponents[index] && (this.gaugeComponents[index].highlightTorus.visible = true);
            this.uiManager.textButton.on('click', callback = () => {
                if (this.slider.calcValue() === measurementConfig[index].rightValue) {
                    this.uiManager.textButton.off('click', callback);
                    if (index === 3) {
                        this.fire('hide_needle');
                    }
                    else {
                        this.gaugeComponents[index] && (this.gaugeComponents[index].highlightTorus.visible = false);
                    }
                    this.startMeasurement(index + 1);
                }
                else {
                    // this.uiManager.showFailPopUp();
                }
            });
        }
        else {
            this.startEngine();
        }
    }
    startEngine() {
        this.actionController.once(ActionControllerEventName.click, this.startEngineButton, () => {
            this.stopAudio();
            this.audioTractor.play();
            let allLevelsFinished = true;
            let nextHash = '#Lobby';
            for (const levelHash in this.levelsManager.levelList) {
                const level = this.levelsManager.levelList[levelHash];
                if (this !== level && levelHash !== '#Lobby') {
                    if (!level.completed) {
                        nextHash = levelHash;
                        allLevelsFinished = false;
                        break;
                    }
                }
            }
            this.showFinalMessage('Vehicle Maintenance', allLevelsFinished);
            this.changeCameraPosition(true);
            this.on('restart_level', () => {
                this.off('restart_level');
                this.off('next_level_button');
                this.resetStage();
                this.levelsManager.levelFlyTo(this);
                this.startLevel();
            });
            this.on('next_level_button', () => {
                this.off('restart_level');
                this.off('next_level_button');
                this.resetStage();
                this.fire('next_level', new ParentEvent('next_level', { level: nextHash }));
            });
        });
    }
    showStartMessage() {
        if (this.completed) {
            this.fire('start_level', new ParentEvent('start_level'));
        }
        else {
            const pop = {
                header: 'Vehicle Maintenance',
                body: 'In this level you are going to do vehicle maintenance. You are going to answer some question regarding the vehicle maintenance. Click continue button to get started.',
                welcomeBodyRows: 4,
            };
            this.uiManager.on('first_button_click', () => {
                this.uiManager.off('first_button_click');
                this.fire('start_level', new ParentEvent('start_level'));
            });
            this.uiManager.showWelcomePopUp(pop);
        }
    }
    showNeedle() {
        const needle = this.needle;
        const startingPosition = needle.position.clone();
        const startingQuaternion = needle.quaternion.clone();
        this.once('hide_needle', () => {
            this.needleTween = new Tween({ alpha: 0 }).to({ alpha: 1 }, 900)
                .onUpdate((alpha) => {
                const currentQuaternion = new Quaternion().setFromEuler(needleConfig.pickedRotation).clone().slerp(startingQuaternion, alpha);
                needle.quaternion.copy(currentQuaternion);
            })
                .onComplete(() => {
                this.needleTween = new Tween({ alpha: 0 }).to({ alpha: 1 }, 900)
                    .onUpdate((alpha) => {
                    const currentPosition = needleConfig.pickedPosition.clone().lerp(startingPosition, alpha);
                    needle.position.copy(currentPosition);
                })
                    .onComplete(() => {
                    this.closeDoor();
                })
                    .start();
            })
                .start();
        });
        this.needleTween = new Tween({ alpha: 0 }).to({ alpha: 1 }, 900)
            .onUpdate((alpha) => {
            const currentPosition = startingPosition.clone().lerp(needleConfig.pickedPosition, alpha);
            needle.position.copy(currentPosition);
        })
            .onComplete(() => {
            this.needleTween = new Tween({ alpha: 0 }).to({ alpha: 1 }, 900)
                .onUpdate((alpha) => {
                const currentQuaternion = startingQuaternion.clone().slerp(new Quaternion().setFromEuler(needleConfig.pickedRotation), alpha);
                needle.quaternion.copy(currentQuaternion);
            })
                .start();
        })
            .start();
    }
    initAssets() {
        this.audioTractor = this.loader.getResource('AUDIO_tractor');
        this.startEngineButton = new Mesh(new PlaneGeometry(.069, .069), new MeshBasicMaterial({
            map: this.loader.getResource('TEXTURE_start_engine_button'),
            transparent: true
        }));
        this.fuelGauge = new Mesh(new PlaneGeometry(...(this.isVr ? [.16, .16] : [.12, .12])), new MeshBasicMaterial({
            map: this.loader.getResource('TEXTURE_fuel_gauge_bc'),
            alphaMap: this.loader.getResource('TEXTURE_fuel_gauge_op'),
            transparent: true
        }));
        this.needle = this.loader.getResource('MODEL_oil_stick');
        // @ts-ignore
        this.needle.children[0].material = new MeshBasicMaterial({
            map: this.loader.getResource('TEXTURE_oil_stick'),
        });
        this.needle.position.set(0.955, 1.1, 6.13);
        this.needle.rotation.set(0.5, 0, -0.5);
        this.addObject(this.needle);
        this.coolantScale = this.loader.getResource('MODEL_coolant_scale');
        this.coolantScale.position.set(1.02225, 1.0825, 6.12525);
        this.coolantScale.rotation.set(0, 0.9, 0);
        this.coolantScale.scale.setScalar(0.01);
        this.addObject(this.coolantScale);
        this.fuelGauge.position.x = this.isVr ? 0.27 : 0;
        this.tractorLabel = new Mesh(new PlaneGeometry(.3136, .0624), new MeshBasicMaterial({
            map: this.loader.getResource('TEXTURE_tractor_label'),
            transparent: true
        }));
        this.tractorLabel.position.set(1.15125, 1.6, 5.935);
        this.tractorLabel.scale.setScalar(3);
        this.tractorLabel.rotation.set(0, 0.9125, 0);
        this.addObject(this.tractorLabel);
        const bodySize = new Vector2(.2, .1);
        const pxScale = 2;
        this.label = new TextComponent({
            size: bodySize,
            pxSize: new Vector2(256 * bodySize.x / bodySize.y * pxScale, 256 * pxScale),
            text: {
                value: 'John Deere \n M300',
                autoWrappingHorizontal: false,
                autoWrapping: false,
                align: 'left',
                style: {
                    family: 'ProximaNova',
                    weight: '600',
                    size: '183px',
                    color: '#000000'
                },
                margin: 0.001,
                lineHeight: 190,
            },
            background: {
                // color: 'white'
                color: '#D4CF43'
            }
        });
        this.label.uiObject.position.set(0.94875, 1.63, 6.2);
        this.label.uiObject.rotation.set(0, .93, 0);
        this.addObject(this.label);
        this.getParts();
        this.setupGauges();
    }
    getParts() {
        const partsList = ['engine_compartment_door004', 'tie_gauge_indicator003', 'coolant_gauge_indicator003', 'tire_inflation_gauge003'];
        const hideList = ['coolant_gauge003', 'oil_gauge003', 'oil_needle004'];
        const engineBayName = 'engine_covering003';
        this.environment.environment.traverse((child) => {
            if (partsList.includes(child.name)) {
                this.parts[child.name] = child;
            }
            else if (hideList.includes(child.name)) {
                child.visible = false;
            }
            else if (child.name === engineBayName) {
                // @ts-ignore
                child.material.side = DoubleSide;
            }
        });
        this.closeDoor();
    }
    prepareMaterials() {
        this.tractor.traverse((child) => {
            if (child && child.material) {
                const mat = new MeshPhongMaterial();
                child.material = mat;
            }
        });
    }
    hideBaseTractor() {
        this.environment.environment.traverse((child) => {
            if (child.name === 'main_body') {
                child.visible = false;
            }
            if (child.name === 'rear_wheels') {
                child.visible = false;
            }
            if (child.name === 'front_wheels') {
                child.visible = false;
            }
        });
    }
    //level
    openDoor() {
        this.parts['engine_compartment_door004'].rotation.set(0, 0, 5);
    }
    closeDoor() {
        this.parts['engine_compartment_door004'].rotation.set(0, 0, 2.4815926535897916);
    }
    setupGauges() {
        const gaugesConfig = [
            {
                object: this.parts['tie_gauge_indicator003'],
                label: 'tires',
                yPos: 0,
                values: {
                    min: 0,
                    current: 36,
                    max: 50
                }
            },
        ];
        this.gaugeComponents.forEach((el, index) => {
            el.initGauge(gaugesConfig[index]);
            el.uiObject.position.setY(gaugesConfig[index].yPos);
            this.tractorAssets.add(el.uiObject);
        });
        this.gaugeComponents[0].uiObject.position.set(0.525, -0.667, 0.57475);
        this.gaugeComponents[0].uiObject.scale.setScalar(2);
        this.parts['tire_inflation_gauge003'].position.set(-16.5, -200, -618.5);
        this.parts['tire_inflation_gauge003'].scale.setScalar(200);
        this.addObject(this.tractorAssets);
        this.tractorAssets.position.set(0.9407, 1.188, 6.1308);
        this.tractorAssets.rotation.set(0, 0.9, 0);
    }
    nextStep(step) {
        if (typeof step !== 'undefined')
            this.currentStep = step;
        switch (this.currentStep) {
            case (1): {
                this.uiManager.hidePopUpScreen();
                this.uiManager.hideText().then(() => {
                    const brandConf = {
                        title: 'Select Manufactory',
                        options: [
                            {
                                text: 'John Deere',
                                correct: true
                            },
                            {
                                text: 'MTZ',
                                correct: false
                            },
                            {
                                text: 'DOG',
                                correct: false
                            }
                        ],
                        buttonSize: new Vector2(0.165, 0.051),
                        margin: 0.016
                    };
                    this.select.init(brandConf);
                    this.uiManager.setText({
                        background: this.uiManager.getTextBackground({
                            size: new Vector2(.562, .22),
                            headerHeight: .06,
                        }),
                        elements: [
                            {
                                object: this.uiManager.getTextHeader({
                                    text: 'Answer the question below',
                                    window: {
                                        size: new Vector2(.510, .028),
                                        scale: 1,
                                        pxScale: 1
                                    }
                                }),
                                margin: 0.016 + 0.014
                            },
                            {
                                object: this.uiManager.getTextBody({
                                    text: 'What’s the brand of the tractor?',
                                    window: {
                                        size: new Vector2(.510, .026),
                                        scale: 1,
                                        pxScale: 1
                                    }
                                }),
                                margin: 0.084 + 0.013
                            },
                            {
                                object: this.select,
                                margin: 0.118 + 0.0255
                            },
                        ]
                    });
                });
                break;
            }
            case (2): {
                this.uiManager.hidePopUpScreen();
                this.uiManager.hideText().then(() => {
                    const modelConf = {
                        title: 'What’s the model of the tractor?',
                        options: [
                            {
                                text: '100',
                                correct: false
                            },
                            {
                                text: '200',
                                correct: false
                            },
                            {
                                text: '300',
                                correct: true
                            }
                        ],
                        buttonSize: new Vector2(0.166, 0.051),
                        margin: 0.016
                    };
                    this.select.init(modelConf);
                    this.uiManager.setText({
                        background: this.uiManager.getTextBackground({
                            size: new Vector2(.562, .22),
                            headerHeight: .06,
                        }),
                        elements: [
                            {
                                object: this.uiManager.getTextHeader({
                                    text: 'Answer the question below',
                                    window: {
                                        size: new Vector2(.510, .028),
                                        scale: 1,
                                        pxScale: 1
                                    }
                                }),
                                margin: 0.016 + 0.014
                            },
                            {
                                object: this.uiManager.getTextBody({
                                    text: 'What’s the model of the tractor?',
                                    window: {
                                        size: new Vector2(.510, .026),
                                        scale: 1,
                                        pxScale: 1
                                    }
                                }),
                                margin: 0.084 + 0.013
                            },
                            {
                                object: this.select,
                                margin: 0.118 + 0.0255
                            },
                        ]
                    });
                });
                break;
            }
            case (3): {
                this.uiManager.hidePopUpScreen();
                this.uiManager.hideText().then(() => {
                    this.uiManager.setText({
                        background: this.uiManager.getTextBackground({
                            size: new Vector2(.562, .355),
                            headerHeight: .06,
                        }),
                        elements: [
                            {
                                object: this.uiManager.getTextHeader({
                                    text: 'Answer the question below',
                                    window: {
                                        size: new Vector2(.510, .028),
                                        scale: 1,
                                        pxScale: 1
                                    }
                                }),
                                margin: 0.016 + 0.014
                            },
                            {
                                object: this.uiManager.getTextBody({
                                    text: 'What is the tire inflation level (PSI)? Read the gauge and click + or - to adjust the value.',
                                    window: {
                                        size: new Vector2(.510, .078),
                                        scale: 1,
                                        pxScale: 2.625
                                    }
                                }),
                                margin: 0.084 + 0.039
                            },
                            {
                                object: this.slider,
                                margin: 0.170 + 0.035
                            },
                            {
                                object: this.uiManager.getTextButton({
                                    text: 'Confirm',
                                    window: {
                                        size: new Vector2(.530, .051),
                                        scale: 1,
                                        pxScale: 1
                                    }
                                }),
                                margin: 0.280 + 0.0255
                            },
                        ]
                    });
                });
                break;
            }
            case (4): {
                this.uiManager.hidePopUpScreen();
                this.uiManager.hideText().then(() => {
                    const text = this.uiManager.getTextBody({
                        text: 'What is the fuel level (1-100)? Read the gauge and \n click + or - to adjust the number.',
                        window: {
                            size: new Vector2(.530, .078),
                            scale: 1,
                            pxScale: 2.625
                        }
                    });
                    const button = this.uiManager.getTextButton({
                        text: 'Confirm',
                        window: {
                            size: new Vector2(.530, .051),
                            scale: 1,
                            pxScale: 1
                        }
                    });
                    if (this.isVr) {
                        text.uiObject.position.x -= .09;
                        button.uiObject.position.x -= 0.09;
                        this.slider.uiObject.position.x -= 0.09;
                    }
                    this.uiManager.setText({
                        background: this.uiManager.getTextBackground({
                            size: this.isVr ? new Vector2(.562 + 0.18, .33) : new Vector2(.562, .355 + 0.15),
                            headerHeight: .06,
                        }),
                        elements: [
                            {
                                object: this.uiManager.getTextHeader({
                                    text: 'Answer the question below',
                                    window: {
                                        size: new Vector2(.510, .028),
                                        scale: 1,
                                        pxScale: 1
                                    }
                                }),
                                margin: 0.016 + 0.014
                            },
                            {
                                object: text,
                                margin: this.isVr ? 0.084 + 0.04 : 0.084 + 0.039 + 0.15
                            },
                            {
                                object: this.fuelGauge,
                                margin: this.isVr ? 0.084 + 0.061 + 0.018 + 0.021 : 0.084 + 0.059
                            },
                            {
                                object: this.slider,
                                margin: this.isVr ? 0.170 + 0.04 : 0.170 + 0.035 + 0.15
                            },
                            {
                                object: button,
                                margin: this.isVr ? 0.280 : 0.280 + 0.0255 + 0.15
                            },
                        ]
                    });
                });
                break;
            }
            case (5): {
                const button = this.uiManager.getTextButton({
                    text: 'Confirm',
                    window: {
                        size: new Vector2(.530, .051),
                        scale: 1,
                        pxScale: 1
                    }
                });
                if (this.isVr) {
                    this.slider.uiObject.position.x = 0;
                    button.uiObject.position.x = 0;
                }
                this.uiManager.hidePopUpScreen();
                this.uiManager.hideText().then(() => {
                    this.uiManager.setText({
                        background: this.uiManager.getTextBackground({
                            size: new Vector2(.562, .355),
                            headerHeight: .06,
                        }),
                        elements: [
                            {
                                object: this.uiManager.getTextHeader({
                                    text: 'Answer the question below',
                                    window: {
                                        size: new Vector2(.510, .028),
                                        scale: 1,
                                        pxScale: 1
                                    }
                                }),
                                margin: 0.016 + 0.014
                            },
                            {
                                object: this.uiManager.getTextBody({
                                    text: 'What`s the coolant level? Look at the coolant reservoir and click + or - to adjust the value.',
                                    window: {
                                        size: new Vector2(.510, .078),
                                        scale: 1,
                                        pxScale: 2.625
                                    }
                                }),
                                margin: 0.084 + 0.039
                            },
                            {
                                object: this.slider,
                                margin: 0.170 + 0.035
                            },
                            {
                                object: button,
                                margin: 0.280 + 0.0255
                            },
                        ]
                    });
                });
                break;
            }
            case (6): {
                this.uiManager.hidePopUpScreen();
                this.uiManager.hideText().then(() => {
                    this.uiManager.setText({
                        background: this.uiManager.getTextBackground({
                            size: new Vector2(.562, .361),
                            headerHeight: .06,
                        }),
                        elements: [
                            {
                                object: this.uiManager.getTextHeader({
                                    text: 'Answer the question below',
                                    window: {
                                        size: new Vector2(.510, .028),
                                        scale: 1,
                                        pxScale: 1
                                    }
                                }),
                                margin: 0.016 + 0.014
                            },
                            {
                                object: this.uiManager.getTextBody({
                                    text: 'What\'s the oil level of this tractor? Check the dipstick and click + or - to enter the oil level.',
                                    window: {
                                        size: new Vector2(.510, .052),
                                        scale: 1,
                                        pxScale: 2.125
                                    }
                                }),
                                margin: 0.092 + 0.026
                            },
                            {
                                object: this.slider,
                                margin: 0.176 + 0.035
                            },
                            {
                                object: this.uiManager.getTextButton({
                                    text: 'Confirm',
                                    window: {
                                        size: new Vector2(.530, .051),
                                        scale: 1,
                                        pxScale: 1
                                    }
                                }),
                                margin: 0.286 + 0.0255
                            },
                        ]
                    });
                });
                break;
            }
            case (7): {
                this.uiManager.hidePopUpScreen();
                this.uiManager.hideText().then(() => {
                    this.uiManager.setText({
                        background: this.uiManager.getTextBackground({
                            size: new Vector2(.562, .250),
                            headerHeight: .06,
                        }),
                        elements: [
                            {
                                object: this.uiManager.getTextHeader({
                                    text: 'Start the engine',
                                    window: {
                                        size: new Vector2(.510, .028),
                                        scale: 1,
                                        pxScale: 1
                                    }
                                }),
                                margin: 0.016 + 0.014
                            },
                            {
                                object: this.uiManager.getTextBody({
                                    text: 'You have checked all information about the tractor! Let’s press the “start” button to start the engine.',
                                    window: {
                                        size: new Vector2(.510, .052),
                                        scale: 1,
                                        pxScale: 2.125
                                    }
                                }),
                                margin: 0.092 + 0.026
                            },
                            {
                                object: this.startEngineButton,
                                margin: 0.158 + 0.0345
                            },
                        ]
                    });
                });
                break;
            }
        }
    }
    stopAudio() {
        this.audioTractor.pause();
        this.audioTractor.currentTime = 0;
    }
    resetStage() {
        this.off('restart_level');
        this.off('next_level_button');
        this.uiManager.off('first_button_click');
        this.stopAudio();
        this.changeCameraPosition(true);
        // this.uiManager.hidePopUpScreen();
        // this.levelsManager.levelFlyTo(this);
        // this.startLevel();
        this.fire('hide_needle');
    }
}
